import React from "react";
import { Grid } from "semantic-ui-react";

export default function ReviewItem({ date, details, actionButton }) {
  return (
    <div className="job-list-item body-blue-text">
      <Grid style={{ paddingRight: 14 }} stackable>
        <Grid.Column
          width={5}
          verticalAlign="middle"
          textAlign="left"
          style={{ padding: 12 }}
        >
          {date}
        </Grid.Column>
        <Grid.Column width={7} verticalAlign="middle" style={{ padding: 12 }}>
          {details}
        </Grid.Column>
        <Grid.Column
          width={4}
          verticalAlign="middle"
          textAlign={"right"}
          style={{ padding: 12 }}
        >
          {actionButton}
        </Grid.Column>
      </Grid>
    </div>
  );
}
